












export default {
    name: 'user-avatar',
    props: {
        userAvatar: {
            type: String,
            default: '',
        },
        countryCode: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        defaultPic: require('@webapp/assets/profile-blank-filled.webp'),
    }),
    computed: {
        avatar() {
            return this.userAvatar || this.defaultPic;
        },
    },
};
